module.exports = __webpack_public_path__ + "images/category_lp/game_console/main-view_f84c7c273cd820bb510ff4f7638f9776.png";